import { RiskLevel } from "@/model/RiskLevel";
import { DefaultHigh, DefaultLower, NullBanner } from "@/model/DefaultBanners";
import EssexLogo from "@/assets/regions/essex-sword-logo.svg";
const IncreasingRisk = {
    rawCopy: `For Increasing Risk scores we recommend you cut down your drinking. Click here to
        <u>book a free online appointment</u> with an alcohol specialist.`,
    logoLink: "https://bookdrinkcoach.as.me/"
};
const HigherRisk = {
    rawCopy: `For Higher Risk scores we recommend you cut down your drinking. Click here to
        <u>book a free online appointment</u> with an alcohol specialist.`,
    logoLink: "https://bookdrinkcoach.as.me/"
};
export default {
    name: "Essex",
    logo: {
        file: EssexLogo,
        width: 544,
        height: 30
    },
    hasFreeAppointments: true,
    showServiceInfoOnResultsSummaryPage: true,
    bannerInfo: {
        default: NullBanner,
        [RiskLevel.Lower]: DefaultLower,
        [RiskLevel.Increasing]: IncreasingRisk,
        [RiskLevel.Higher]: HigherRisk,
        [RiskLevel.High]: DefaultHigh
    },
    regions: [
        "Basildon",
        "Braintree",
        "Brentwood",
        "Castle Point",
        "City of Chelmsford",
        "Colchester",
        "Epping Forest",
        "Harlow",
        "Maldon",
        "Rochford",
        "Tendring",
        "Uttlesford"
    ],
    clinics: [
        {
            name: "Essex Arc",
            isPrimaryProvider: true,
            description: "Contact ${name}",
            phone: ["01376 316126"],
            email: "essex.arc@phoenixfutures.org.uk",
            website: "https://www.phoenix-futures.org.uk/phoenix-futures-for/people-and-families-who-use-our-services/find-a-service/essex-alcohol-recovery-community/"
        },
        {
            name: "Essex Alcohol Recovery Community (ARC) – Mid Essex - Chelmsford",
            location: { lat: 51.7301173, lng: 0.470755 },
            email: "essex.arc@phoenixfutures.org.uk",
            address: "32 Moulsham Street, Essex, CM2 0HX",
            phone: ["01376 316126"],
            website: "https://www.phoenix-futures.org.uk/phoenix-futures-for/people-and-families-who-use-our-services/find-a-service/essex-alcohol-recovery-community/"
        },
        {
            name: "Essex Alcohol Recovery Community (ARC) – North Essex - Colchester",
            location: { lat: 51.7301173, lng: 0.4685663 },
            email: "essex.arc@phoenixfutures.org.uk",
            address: "Open Road, 5A Queen Street, Colchester, Essex, CO1 3QD",
            phone: ["01376 316126"],
            website: "https://www.phoenix-futures.org.uk/phoenix-futures-for/people-and-families-who-use-our-services/find-a-service/essex-alcohol-recovery-community/"
        },
        {
            name: "Essex Alcohol Recovery Community (ARC) – West Essex – Harlow",
            location: { lat: 51.7753071, lng: 0.1122493 },
            email: "essex.arc@phoenixfutures.org.uk",
            address: "118-120 The Stow, Harlow, Essex, CM20 3AS",
            phone: ["01376 316126"],
            website: "https://www.phoenix-futures.org.uk/phoenix-futures-for/people-and-families-who-use-our-services/find-a-service/essex-alcohol-recovery-community/"
        },
        {
            name: "Essex Alcohol Recovery Community (ARC) – North Essex – Clacton",
            location: { lat: 51.7907118, lng: 1.1480027 },
            email: "essex.arc@phoenixfutures.org.uk",
            address: "Trinity Methodist Church, 84D Pier Avenue, Clacton On Sea, CO15 1NJ",
            phone: ["01376 316126"],
            website: "https://www.phoenix-futures.org.uk/phoenix-futures-for/people-and-families-who-use-our-services/find-a-service/essex-alcohol-recovery-community/"
        },
        {
            alwaysShowInResults: true,
            name: "Essex Alcohol Recovery Community (ARC) – South Essex – Basildon",
            email: "essex.arc@phoenixfutures.org.uk",
            phone: ["01376 316126"],
            website: "https://www.phoenix-futures.org.uk/phoenix-futures-for/people-and-families-who-use-our-services/find-a-service/essex-alcohol-recovery-community/"
        }
    ]
};
//# sourceMappingURL=Essex.js.map